import {Avatar, Modal, Radio} from 'antd'
import classnames from 'classnames'
import _ from 'lodash'
import {LocalContext} from 'modules/local/LocalContext'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {ReactReduxContext} from 'react-redux'
import useToggle from 'react-use/lib/useToggle'
import {getLogin} from 'redux/selectors'
import {NullAsDefault} from 'views/Shared'

export const LanguageSwitch = ({title, onToggle = NullAsDefault}) => {
    const t = useTranslate()
    const [isToggle, toggle] = useToggle()
    const {lang, changeLang, changeContentLang} = useContext(LocalContext)
    const [displayLanguage, setDisplayLanguage] = useState(lang)
    const {store} = useContext(ReactReduxContext)
    const login = getLogin(store.getState())
    const following_languages_maximum = _.get(login, 'following_languages_maximum', 1)
    const _languages = _.get(login, 'following_languages', ['vi'])
    const following_languages = _.isEmpty(_languages) ? ['vi'] : _languages
    const [contentLanguages, setContentLanguages] = useState(following_languages)
    const [indeterminate, setIndeterminate] = useState(true)
    const [checkAll, setCheckAll] = useState(false)
    const langArray = ['vi', 'en']

    const handleToggle = (value) => {
        toggle(value)
        onToggle(value)
    }

    return (
        <React.Fragment>
            <div className="flex items-center justify-end">
                <div onClick={() => {handleToggle(true)}} style={{ padding: 2 }} className="flex cursor-pointer">
                    {title}
                </div>
            </div>
            {isToggle && (
                <Modal
                    className="custom-modal"
                    wrapClassName="rounded-lg"
                    style={{minHeight: 420, borderRadius: 10}}
                    title={
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('Choose language')}
                        </div>
                    }
                    open={isToggle}
                    header={null}
                    footer={null}
                    onCancel={() => {
                        handleToggle(false)
                    }}>
                    <div className="flex flex-col gap-6">
                        <div className="flex flex-col gap-3">
                            {/*<div className="font-medium text-color-200 italic">*/}
                            {/*    {`${t('language')} : `}*/}
                            {/*</div>*/}
                            <div className="flex-col">
                                <Radio.Group
                                    className="w-full"
                                    onChange={(e) => {
                                        setDisplayLanguage(e.target.value)
                                        changeLang(e.target.value)
                                    }}
                                    value={displayLanguage}>
                                    <React.Fragment>
                                        {langArray.map((value, key) => (
                                            <Radio
                                                key={key}
                                                value={value}
                                                className={classnames(
                                                    'flex items-center rounded-lg hover:background-200 p-3',
                                                    lang === value
                                                        ? 'text-primary font-bold'
                                                        : 'font-normal'
                                                )}>
                                                <div className="w-full flex items-center gap-3 px-4">
                                                    <Avatar
                                                        size={36}
                                                        className="background-200 flex flex-center uppercase">
                                                        <span className="font-bold text-sm text-primary">{value}</span>
                                                    </Avatar>
                                                    <div className="px-3 flex-1">{t(value)}</div>
                                                </div>
                                            </Radio>
                                        ))}
                                    </React.Fragment>
                                </Radio.Group>
                            </div>
                        </div>
                        {/*<div className="flex flex-col">*/}
                        {/*    <div className="font-medium text-color-200 italic">*/}
                        {/*        {`${t('Content language')} : `}*/}
                        {/*    </div>*/}
                        {/*    <div className="flex-col">*/}
                        {/*        <div className="px-3 my-3">*/}
                        {/*            <Checkbox*/}
                        {/*                disabled={langArray.length > following_languages_maximum}*/}
                        {/*                indeterminate={indeterminate}*/}
                        {/*                onChange={(e) => {*/}
                        {/*                    setContentLanguages(e.target.checked ? langArray : [])*/}
                        {/*                    setIndeterminate(false)*/}
                        {/*                    setCheckAll(e.target.checked)*/}

                        {/*                    // Update to Server*/}
                        {/*                    changeContentLang(*/}
                        {/*                        langArray.reduce((result, value, i) => {*/}
                        {/*                            result += i === 0 ? value : ',' + value*/}
                        {/*                            return result*/}
                        {/*                        }, '')*/}
                        {/*                    )*/}
                        {/*                }}*/}
                        {/*                checked={checkAll}>*/}
                        {/*                <span className="ml-4 text-color-200">{t('check all')}</span>*/}
                        {/*            </Checkbox>*/}
                        {/*        </div>*/}
                        {/*        <Checkbox.Group*/}
                        {/*            style={{width: '100%'}}*/}
                        {/*            value={contentLanguages}*/}
                        {/*            onChange={(checkedValues) => {*/}
                        {/*                if (checkedValues.length > following_languages_maximum) {*/}
                        {/*                    Modal.warning({*/}
                        {/*                        title: t('Hello you'),*/}
                        {/*                        className: 'custom-modal',*/}
                        {/*                        content: t(*/}
                        {/*                            'Your current account only allows to follow in one language, if you want to remove this limit, please upgrade to a higher package. Thank you'*/}
                        {/*                        ),*/}
                        {/*                        okText: t('got it'),*/}
                        {/*                        okButtonProps: {*/}
                        {/*                            className:*/}
                        {/*                                'no-border no-shadow no-text-shadow rounded-full',*/}
                        {/*                        },*/}
                        {/*                    })*/}
                        {/*                    return*/}
                        {/*                }*/}
                        {/*                changeContentLang(checkedValues.join(','))*/}

                        {/*                setContentLanguages(checkedValues)*/}
                        {/*                setIndeterminate(*/}
                        {/*                    !!checkedValues.length &&*/}
                        {/*                    checkedValues.length < langArray.length*/}
                        {/*                )*/}
                        {/*                setCheckAll(checkedValues.length === langArray.length)*/}
                        {/*            }}>*/}
                        {/*            <React.Fragment>*/}
                        {/*                {langArray.map((value, key) => (*/}
                        {/*                    <div key={key} className="clearfix">*/}
                        {/*                        <Checkbox*/}
                        {/*                            key={key}*/}
                        {/*                            value={value}*/}
                        {/*                            className={classnames(*/}
                        {/*                                'flex items-center rounded-lg hover:background-200 p-3 custom-checkbox-lang',*/}
                        {/*                                _.includes(contentLanguages, value)*/}
                        {/*                                    ? 'text-primary font-bold'*/}
                        {/*                                    : 'font-normal'*/}
                        {/*                            )}>*/}
                        {/*                            <div className="flex items-center gap-3 px-4">*/}
                        {/*                                /!*<FlagIcon size={30} type={value}/>*!/*/}
                        {/*                                <Avatar*/}
                        {/*                                    size={30}*/}
                        {/*                                    className="background-200 flex flex-center uppercase">*/}
                        {/*                                    <span className="font-bold text-sm text-primary">{value}</span>*/}
                        {/*                                </Avatar>*/}
                        {/*                                <div className="px-3">{t(value)}</div>*/}
                        {/*                            </div>*/}
                        {/*                        </Checkbox>*/}
                        {/*                    </div>*/}
                        {/*                ))}*/}
                        {/*            </React.Fragment>*/}
                        {/*        </Checkbox.Group>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </Modal>
            )}
        </React.Fragment>
    )
}
